import React, { useState } from 'react';
import WizardActionBar from './WizardActionBar/WizardActionBar';
import WizardProgressBar from './WizardProgressBar/WizardProgressBar';
import ProjectsSelection from '../ProjectsSelection/ProjectsSelection';

const WizardStages = props => {
  const {activeStage, selectedSubProject} = props;


  return (
    <>
      <div className="stage-content stages overflow-hidden">
        <WizardProgressBar 
          isDisplay={true} 
          activeStage={activeStage} 
          type='top'
          selectedSubProject={selectedSubProject}
        />
        <div className='flex-column flex-1 overflow-hidden'>
          {props.getStageContent()}
        </div>
        
        <WizardActionBar
          onNext={props.onNext}
          onBack={props.onBack}
          isNextDisabled={props.isNextDisabled} //this should be a method which return true or false based on the current stage
          isNextDisplayed={props.isNextDisplayed} //this should be a method which return true or false based on the current stage, each stage will update JobConfiguration state to show/hide next button
          activeStage={activeStage}
          onCancel={() => {}}
        ></WizardActionBar>
      </div>
    </>
  );
};

export default WizardStages;
